import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'
]
})
export class NotFoundComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/core.module/components/not-found.component/not-found.component.ts